import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import Icon from '@components/Icon.vue';

import { faClockRotateLeft } from '@icons/solid/faClockRotateLeft';
import { faArrowRight } from '@icons/solid/faArrowRight';

export interface Props {
  type: 'historical' | 'projected';
  text?: boolean;
}


const __default__ = { name: 'UsageTypeEmblem' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: null,
    text: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { type: 'historical' | 'projected', text: boolean };



const icon = computed(() => {
  return props.type === 'historical' ? faClockRotateLeft : faArrowRight;
});

const label = computed(() => {
  if (!props.text) {
    return null;
  }

  return props.type === 'historical' ? 'Historical' : 'Projected';
});

return { __sfc: true,props, icon, label, Icon }
}

})